!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/InputSubtext"), require("ati-ui-react/components/ReactTooltip"), require("ati-ui-react/components/icons/None"), require("react-autosuggest")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/InputSubtext", "ati-ui-react/components/ReactTooltip", "ati-ui-react/components/icons/None", "react-autosuggest"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/InputSubtext"), require("ati-ui-react/components/ReactTooltip"), require("ati-ui-react/components/icons/None"), require("react-autosuggest")) : e["ati-ui-react"] = t(e.React, e[void 0], e[void 0], e[void 0], e[void 0]);
}(this, function (r, n, o, s, i) {
  return u = {}, a.m = l = {
    0: function (e, t) {
      e.exports = r;
    },
    10: function (e, t, r) {
      "use strict";

      r.d(t, "b", function () {
        return n;
      }), r.d(t, "a", function () {
        return o;
      });
      var n = function (t) {
          for (var e = arguments.length, r = Array(1 < e ? e - 1 : 0), n = 1; n < e; n++) r[n - 1] = arguments[n];
          return r.filter(Boolean).map(function (e) {
            return t[e];
          }).join(" ");
        },
        o = function () {
          for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          return t.filter(Boolean).join(" ");
        };
    },
    102: function (e, t) {
      e.exports = function (n, o) {
        var s = [];
        return 0 === o.length ? s.push({
          text: n,
          highlight: !1
        }) : 0 < o[0][0] && s.push({
          text: n.slice(0, o[0][0]),
          highlight: !1
        }), o.forEach(function (e, t) {
          var r = e[0],
            e = e[1];
          s.push({
            text: n.slice(r, e),
            highlight: !0
          }), t === o.length - 1 ? e < n.length && s.push({
            text: n.slice(e, n.length),
            highlight: !1
          }) : e < o[t + 1][0] && s.push({
            text: n.slice(e, o[t + 1][0]),
            highlight: !1
          });
        }), s;
      };
    },
    169: function (e, t, r) {
      var n;
      n = function () {
        for (var i = {
            map: {}
          }, e = [{
            base: " ",
            letters: " "
          }, {
            base: "A",
            letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
          }, {
            base: "AA",
            letters: "Ꜳ"
          }, {
            base: "AE",
            letters: "ÆǼǢ"
          }, {
            base: "AO",
            letters: "Ꜵ"
          }, {
            base: "AU",
            letters: "Ꜷ"
          }, {
            base: "AV",
            letters: "ꜸꜺ"
          }, {
            base: "AY",
            letters: "Ꜽ"
          }, {
            base: "B",
            letters: "BⒷＢḂḄḆɃƂƁ"
          }, {
            base: "C",
            letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
          }, {
            base: "D",
            letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
          }, {
            base: "DZ",
            letters: "ǱǄ"
          }, {
            base: "Dz",
            letters: "ǲǅ"
          }, {
            base: "E",
            letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
          }, {
            base: "F",
            letters: "FⒻＦḞƑꝻ"
          }, {
            base: "G",
            letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
          }, {
            base: "H",
            letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
          }, {
            base: "I",
            letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
          }, {
            base: "J",
            letters: "JⒿＪĴɈ"
          }, {
            base: "K",
            letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
          }, {
            base: "L",
            letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
          }, {
            base: "LJ",
            letters: "Ǉ"
          }, {
            base: "Lj",
            letters: "ǈ"
          }, {
            base: "M",
            letters: "MⓂＭḾṀṂⱮƜ"
          }, {
            base: "N",
            letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
          }, {
            base: "NJ",
            letters: "Ǌ"
          }, {
            base: "Nj",
            letters: "ǋ"
          }, {
            base: "O",
            letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
          }, {
            base: "OI",
            letters: "Ƣ"
          }, {
            base: "OO",
            letters: "Ꝏ"
          }, {
            base: "OU",
            letters: "Ȣ"
          }, {
            base: "P",
            letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
          }, {
            base: "Q",
            letters: "QⓆＱꝖꝘɊ"
          }, {
            base: "R",
            letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
          }, {
            base: "S",
            letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
          }, {
            base: "T",
            letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
          }, {
            base: "Th",
            letters: "Þ"
          }, {
            base: "TZ",
            letters: "Ꜩ"
          }, {
            base: "U",
            letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
          }, {
            base: "V",
            letters: "VⓋＶṼṾƲꝞɅ"
          }, {
            base: "VY",
            letters: "Ꝡ"
          }, {
            base: "W",
            letters: "WⓌＷẀẂŴẆẄẈⱲ"
          }, {
            base: "X",
            letters: "XⓍＸẊẌ"
          }, {
            base: "Y",
            letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
          }, {
            base: "Z",
            letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
          }, {
            base: "a",
            letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
          }, {
            base: "aa",
            letters: "ꜳ"
          }, {
            base: "ae",
            letters: "æǽǣ"
          }, {
            base: "ao",
            letters: "ꜵ"
          }, {
            base: "au",
            letters: "ꜷ"
          }, {
            base: "av",
            letters: "ꜹꜻ"
          }, {
            base: "ay",
            letters: "ꜽ"
          }, {
            base: "b",
            letters: "bⓑｂḃḅḇƀƃɓ"
          }, {
            base: "c",
            letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
          }, {
            base: "d",
            letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
          }, {
            base: "dz",
            letters: "ǳǆ"
          }, {
            base: "e",
            letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
          }, {
            base: "f",
            letters: "fⓕｆḟƒꝼ"
          }, {
            base: "ff",
            letters: "ﬀ"
          }, {
            base: "fi",
            letters: "ﬁ"
          }, {
            base: "fl",
            letters: "ﬂ"
          }, {
            base: "ffi",
            letters: "ﬃ"
          }, {
            base: "ffl",
            letters: "ﬄ"
          }, {
            base: "g",
            letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
          }, {
            base: "h",
            letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
          }, {
            base: "hv",
            letters: "ƕ"
          }, {
            base: "i",
            letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
          }, {
            base: "j",
            letters: "jⓙｊĵǰɉ"
          }, {
            base: "k",
            letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
          }, {
            base: "l",
            letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
          }, {
            base: "lj",
            letters: "ǉ"
          }, {
            base: "m",
            letters: "mⓜｍḿṁṃɱɯ"
          }, {
            base: "n",
            letters: "nñnⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
          }, {
            base: "nj",
            letters: "ǌ"
          }, {
            base: "o",
            letters: "߀oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
          }, {
            base: "oe",
            letters: "Œœ"
          }, {
            base: "oi",
            letters: "ƣ"
          }, {
            base: "ou",
            letters: "ȣ"
          }, {
            base: "oo",
            letters: "ꝏ"
          }, {
            base: "p",
            letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
          }, {
            base: "q",
            letters: "qⓠｑɋꝗꝙ"
          }, {
            base: "r",
            letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
          }, {
            base: "s",
            letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
          }, {
            base: "ss",
            letters: "ß"
          }, {
            base: "t",
            letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
          }, {
            base: "th",
            letters: "þ"
          }, {
            base: "tz",
            letters: "ꜩ"
          }, {
            base: "u",
            letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
          }, {
            base: "v",
            letters: "vⓥｖṽṿʋꝟʌ"
          }, {
            base: "vy",
            letters: "ꝡ"
          }, {
            base: "w",
            letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
          }, {
            base: "x",
            letters: "xⓧｘẋẍ"
          }, {
            base: "y",
            letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
          }, {
            base: "z",
            letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
          }], t = 0, r = e.length; t < r; t++) for (var n = e[t].letters.split(""), o = 0, s = n.length; o < s; o++) i.map[n[o]] = e[t].base;
        return i.clean = function (e) {
          if (!e || !e.length || e.length < 1) return "";
          for (var t, r = "", n = e.split(""), o = 0, s = n.length; o < s; o++) r += (t = n[o]) in i.map ? i.map[t] : t;
          return r;
        }, i;
      }, e.exports ? e.exports = n() : void 0 === (n = "function" == typeof (n = n) ? n.call(t, r, t, e) : n) || (e.exports = n);
    },
    17: function (e, t) {
      e.exports = n;
    },
    19: function (e, t, r) {
      "use strict";

      e.exports = function (e) {
        for (var t = "", r = e = void 0 === e ? 21 : e; r--;) t += "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW"[64 * Math.random() | 0];
        return t;
      };
    },
    193: function (e, t, r) {
      (t = e.exports = r(4)()).push([e.i, ".pSKLl-2-0-721{display:block;position:relative;font-family:Verdana,Dejavu Sans,Geneva,Tahoma,sans-serif}._2IjY4-2-0-721{display:flex;align-items:center;padding:0 10px;position:relative;border:1px solid #ccc;background:#fff;border-radius:2px;outline:0}._2IjY4-2-0-721:hover{border:1px solid #8c969d}._2IjY4-2-0-721.gtybm-2-0-721{border:1px solid #8c969d;box-shadow:0 1px 2px rgba(0,0,0,.21)}._2IjY4-2-0-721._3qdlE-2-0-721{position:absolute;right:0;top:1px;bottom:1px;background-image:linear-gradient(90deg,hsla(0,0%,100%,.0001),#fff);width:30px}._2IjY4-2-0-721.cXbIF-2-0-721{background-color:#f1f1f1;border:1px solid #ccc;cursor:not-allowed}._2IjY4-2-0-721.cXbIF-2-0-721 ._2zKjC-2-0-721{color:#b8b8b8;cursor:not-allowed}._2IjY4-2-0-721._3_ABx-2-0-721{background:#fff0f2;border-color:#d0021b}._2IjY4-2-0-721._3_ABx-2-0-721._3qdlE-2-0-721{background-image:linear-gradient(90deg,hsla(0,0%,100%,.0001),#fff0f2)}._2IjY4-2-0-721 ._3mkqK-2-0-721{right:30px}._1qqI3-2-0-721{width:100%;position:relative;overflow:hidden}._u66T-2-0-721{display:none;position:absolute;top:100%;width:100%;margin-top:-1px;background:#fff;border:1px solid #8c969d;z-index:99;overflow:hidden;box-sizing:border-box}._2BoFr-2-0-721{display:block;max-height:200px;overflow:auto}._2rs2q-2-0-721{line-height:10px;padding-right:8px}._2R7HO-2-0-721{margin-left:8px;line-height:10px}._2Hzkx-2-0-721{cursor:pointer}._2Hzkx-2-0-721:hover svg path{fill:#39444f}._2zKjC-2-0-721{width:100%;background:none;border:0;padding:5px 0;font-size:12px;font-weight:400;color:rgba(6,21,35,.8);position:relative;height:30px;line-height:30px;outline:0;font-family:Verdana,Dejavu Sans,Geneva,Tahoma,sans-serif;box-sizing:border-box}._2zKjC-2-0-721::-moz-placeholder{color:#b8b8b8}._2zKjC-2-0-721:-ms-input-placeholder{color:#b8b8b8}._2zKjC-2-0-721::placeholder{color:#b8b8b8}._2zKjC-2-0-721:focus{outline:0}._2h8IT-2-0-721{position:absolute;top:0;left:0;right:0;font-size:12px;font-weight:400;color:#b8b8b8;white-space:nowrap;line-height:30px}._12M5T-2-0-721{padding:0;overflow-y:auto;max-height:100%;position:relative}._2r-X6-2-0-721,._12M5T-2-0-721{display:block;list-style:none;margin:0}._2r-X6-2-0-721{padding:8px 12px;font-size:12px;line-height:18px;color:#596e81;cursor:pointer}.lrRTw-2-0-721{background:rgba(71,140,200,.3)}._3h3G_-2-0-721{font-weight:700;color:rgba(6,21,35,.8);text-decoration:underline}", ""]), t.locals = {
        container: "pSKLl-2-0-721",
        label: "_2IjY4-2-0-721",
        focused: "gtybm-2-0-721",
        gradient: "_3qdlE-2-0-721",
        disabled: "cXbIF-2-0-721",
        input: "_2zKjC-2-0-721",
        error: "_3_ABx-2-0-721",
        "gradient-pad": "_3mkqK-2-0-721",
        "input-wrapper": "_1qqI3-2-0-721",
        suggestionsContainer: "_u66T-2-0-721",
        suggestionsContainerOpen: "_2BoFr-2-0-721",
        before: "_2rs2q-2-0-721",
        "after-icon": "_2R7HO-2-0-721",
        "clear-after-icon": "_2Hzkx-2-0-721",
        placeholder: "_2h8IT-2-0-721",
        suggestionsList: "_12M5T-2-0-721",
        suggestion: "_2r-X6-2-0-721",
        suggestionHighlighted: "lrRTw-2-0-721",
        match: "_3h3G_-2-0-721"
      };
    },
    2: function (e, t, o) {
      "use strict";

      var r,
        n,
        a = function () {
          return r = void 0 === r ? !(!(window && document && document.all) || window.atob) : r;
        },
        s = (n = {}, function (e) {
          if (void 0 === n[e]) {
            var t = document.querySelector(e);
            if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
              t = t.contentDocument.head;
            } catch (e) {
              t = null;
            }
            n[e] = t;
          }
          return n[e];
        }),
        u = [];
      function c(e) {
        for (var t = -1, r = 0; r < u.length; r++) if (u[r].identifier === e) {
          t = r;
          break;
        }
        return t;
      }
      function l(e, t) {
        for (var r = {}, n = [], o = 0; o < e.length; o++) {
          var s = e[o],
            i = t.base ? s[0] + t.base : s[0],
            a = r[i] || 0,
            l = "".concat(i, " ").concat(a);
          r[i] = a + 1;
          a = c(l), s = {
            css: s[1],
            media: s[2],
            sourceMap: s[3]
          };
          -1 !== a ? (u[a].references++, u[a].updater(s)) : u.push({
            identifier: l,
            updater: function (t, e) {
              var r, n, o;
              {
                var s;
                o = e.singleton ? (s = h++, r = g = g || p(e), n = f.bind(null, r, s, !1), f.bind(null, r, s, !0)) : (r = p(e), n = function (e, t, r) {
                  var n = r.css,
                    o = r.media,
                    r = r.sourceMap;
                  o ? e.setAttribute("media", o) : e.removeAttribute("media");
                  r && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */"));
                  if (e.styleSheet) e.styleSheet.cssText = n;else {
                    for (; e.firstChild;) e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(n));
                  }
                }.bind(null, r, e), function () {
                  !function (e) {
                    if (null === e.parentNode) return;
                    e.parentNode.removeChild(e);
                  }(r);
                });
              }
              return n(t), function (e) {
                e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || n(t = e) : o();
              };
            }(s, t),
            references: 1
          }), n.push(l);
        }
        return n;
      }
      function p(e) {
        var t,
          r = document.createElement("style"),
          n = e.attributes || {};
        if (void 0 !== n.nonce || (t = o.nc) && (n.nonce = t), Object.keys(n).forEach(function (e) {
          r.setAttribute(e, n[e]);
        }), "function" == typeof e.insert) e.insert(r);else {
          e = s(e.insert || "head");
          if (!e) throw Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          e.appendChild(r);
        }
        return r;
      }
      var i,
        d = (i = [], function (e, t) {
          return i[e] = t, i.filter(Boolean).join("\n");
        });
      function f(e, t, r, n) {
        r = r ? "" : n.media ? "@media ".concat(n.media, " {").concat(n.css, "}") : n.css;
        e.styleSheet ? e.styleSheet.cssText = d(t, r) : (n = document.createTextNode(r), (r = e.childNodes)[t] && e.removeChild(r[t]), r.length ? e.insertBefore(n, r[t]) : e.appendChild(n));
      }
      var g = null,
        h = 0;
      e.exports = function (e, s) {
        (s = s || {}).singleton || "boolean" == typeof s.singleton || (s.singleton = a());
        var i = l(e = e || [], s);
        return function (e) {
          if ("[object Array]" === Object.prototype.toString.call(e = e || [])) {
            for (var t = 0; t < i.length; t++) {
              var r = c(i[t]);
              u[r].references--;
            }
            for (var e = l(e, s), n = 0; n < i.length; n++) {
              var o = c(i[n]);
              0 === u[o].references && (u[o].updater(), u.splice(o, 1));
            }
            i = e;
          }
        };
      };
    },
    26: function (e, t) {
      e.exports = o;
    },
    360: function (e, t) {
      e.exports = i;
    },
    361: function (e, t, r) {
      var n = r(169).clean,
        s = /[.*+?^${}()|[\]\\]/g,
        i = /[a-z0-9_]/i,
        a = /\s+/;
      e.exports = function (o, e) {
        return o = n(o), (e = n(e)).trim().split(a).filter(function (e) {
          return 0 < e.length;
        }).reduce(function (e, t) {
          var r = t.length,
            n = i.test(t[0]) ? "\\b" : "",
            t = RegExp(n + t.replace(s, "\\$&"), "i"),
            t = o.search(t);
          return -1 < t && (e.push([t, t + r]), o = o.slice(0, t) + Array(r + 1).join(" ") + o.slice(t + r)), e;
        }, []).sort(function (e, t) {
          return e[0] - t[0];
        });
      };
    },
    4: function (e, t) {
      e.exports = function () {
        var i = [];
        return i.toString = function () {
          for (var e = [], t = 0; t < this.length; t++) {
            var r = this[t];
            r[2] ? e.push("@media " + r[2] + "{" + r[1] + "}") : e.push(r[1]);
          }
          return e.join("");
        }, i.i = function (e, t) {
          "string" == typeof e && (e = [[null, e, ""]]);
          for (var r = {}, n = 0; n < this.length; n++) {
            var o = this[n][0];
            "number" == typeof o && (r[o] = !0);
          }
          for (n = 0; n < e.length; n++) {
            var s = e[n];
            "number" == typeof s[0] && r[s[0]] || (t && !s[2] ? s[2] = t : t && (s[2] = "(" + s[2] + ") and (" + t + ")"), i.push(s));
          }
        }, i;
      };
    },
    50: function (e, t) {
      e.exports = s;
    },
    570: function (e, t, r) {
      "use strict";

      r.r(t), r.d(t, "default", function () {
        return j;
      });
      var n = r(0),
        c = r.n(n),
        t = r(360),
        s = r.n(t),
        n = r(361),
        i = r.n(n),
        t = r(102),
        a = r.n(t),
        n = r(26),
        p = r.n(n),
        t = r(50),
        d = r.n(t),
        f = r(10),
        n = r(17),
        l = r.n(n),
        t = r(19),
        g = r.n(t),
        n = r(2),
        t = r.n(n),
        n = r(193),
        r = r.n(n),
        n = {
          insert: "head",
          singleton: !1
        },
        h = (t()(r.a, n), r.a.locals || {});
      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function u(t, e) {
        var r,
          n = Object.keys(t);
        return Object.getOwnPropertySymbols && (r = Object.getOwnPropertySymbols(t), e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r)), n;
      }
      function b(n) {
        for (var e = 1; e < arguments.length; e++) {
          var o = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(o), !0).forEach(function (e) {
            var t, r;
            t = n, e = o[r = e], r in t ? Object.defineProperty(t, r, {
              value: e,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[r] = e;
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o)) : u(Object(o)).forEach(function (e) {
            Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(o, e));
          });
        }
        return n;
      }
      function m() {
        return (m = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r,
              n = arguments[t];
            for (r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
      }
      function v(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      function y(e, t) {
        return (y = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function x(r) {
        var n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var e,
            t = S(r);
          return e = n ? (e = S(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), t = this, !(e = e) || "object" !== o(e) && "function" != typeof e ? function (e) {
            if (void 0 !== e) return e;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }(t) : e;
        };
      }
      function S(e) {
        return (S = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      r = function () {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && y(e, t);
        }(o, c.a.Component);
        var e,
          t,
          r,
          n = x(o);
        function o() {
          var u;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, o), (u = n.call(this)).suggestionHighlightedScroll = function (e) {
            var t = u.suggestionsContainer,
              r = u.highlightedItemIndex;
            r && t && (40 === e.keyCode || 38 === e.keyCode) && (t.scrollTop = r.offsetTop + (r.clientHeight + 18 - t.clientHeight));
          }, u.onChange = function (e, t) {
            var r = t.newValue,
              t = t.method,
              r = r.replace(/^\s/i, "").replace(/\s{2,}/i, " ");
            "type" !== t && "enter" !== t && "click" !== t || u.props.onChange(r, u.props.id);
          }, u.onSuggestionsFetchRequested = function (e) {
            var t = e.value,
              e = e.reason;
            "input-changed" !== e && "input-focused" !== e || u.props.onSuggestionsFetchRequested({
              value: t,
              reason: e
            }, u.props.id);
          }, u.onSuggestionsClearRequested = function () {
            return u.setState({
              placeholder: null
            }), !!u.props.onSuggestionsClearRequested && u.props.onSuggestionsClearRequested(u.props.id);
          }, u.getSuggestionValue = function (e) {
            return e[u.props.valueProperty];
          }, u.renderSuggestion = function (e, t) {
            t = t.query, t = i()(e[u.props.searchProperty], t), t = a()(e[u.props.searchProperty], t);
            return c.a.createElement("div", {
              className: "suggestion"
            }, t.map(function (e, t) {
              return c.a.createElement("span", {
                key: "hl-id-".concat(t.toString()),
                className: e.highlight ? h.match : ""
              }, e.text);
            }));
          }, u.renderSuggestionsContainer = function (e) {
            var t = e.containerProps,
              e = e.children,
              r = e && e.props && e.props.highlightedItemIndex;
            return c.a.createElement("div", m({}, t, {
              className: [t.className, u.props.dropDownClassName || ""].join(" "),
              ref: function (e) {
                u.suggestionsContainer = e, t.ref(e);
              }
            }), c.a.createElement("div", {
              ref: function (e) {
                null !== (u.node = e) && e.children && e.children[0] && 0 <= r && e.children[0].children[r] && (u.highlightedItemIndex = e.children[0].children[r]);
              }
            }, e));
          }, u.onSuggestionHighlighted = function (e) {
            e = e.suggestion;
            u.state.focused && u.setState({
              placeholder: e
            });
          }, u.clearValue = function () {
            u.props.onChange("", u.props.id), u.props.onClear && u.props.onClear();
          }, u.handleFocus = function (e) {
            u.setState({
              focused: !0
            }), u.props.onFocus && u.props.onFocus(e, u.props.id);
          }, u.handleBlur = function (e) {
            u.setState({
              focused: !1
            }), u.props.onBlur && u.props.onBlur(e, u.props.id);
          }, u.renderInputComponent = function (t) {
            var e = u.props.value.trim(),
              r = u.props,
              n = r.before,
              o = r.after,
              s = r.labelClassName,
              i = r.searchProperty,
              a = r.noFog,
              l = RegExp("^".concat(e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")), "i"),
              r = null;
            a || (r = e ? c.a.createElement("div", {
              className: Object(f.b)(h, "gradient", "gradient-pad")
            }) : c.a.createElement("div", {
              className: h.gradient
            }));
            a = null;
            u.state.placeholder && (a = u.state.placeholder[i].replace(l, e));
            l = l.test(a);
            return c.a.createElement("label", {
              className: [h.label, s || "", u.state.focused ? h.focused : "", u.props.error ? h.error : "", u.props.disabled ? h.disabled : ""].join(" ")
            }, n && c.a.createElement("div", {
              className: h.before
            }, n), c.a.createElement("div", {
              className: h["input-wrapper"]
            }, c.a.createElement("div", {
              ref: function (e) {
                u.placeholder = e, t.ref && t.ref(e);
              },
              className: (u.props.theme && u.props.theme.placeholder ? u.props.theme : h).placeholder
            }, !e.length || l ? a : ""), c.a.createElement("input", m({}, t, {
              placeholder: a ? "" : t.placeholder,
              ref: function (e) {
                u.input = e;
              }
            }))), r, e && !0 !== u.props.disabled && c.a.createElement(c.a.Fragment, null, c.a.createElement("div", {
              className: [h["after-icon"], h["clear-after-icon"]].join(" "),
              onClick: u.clearValue,
              role: "presentation",
              "data-tip": !0,
              "data-for": "autosuggest-close-icon"
            }, c.a.createElement(d.a, {
              color: "#b8b8b8",
              width: "14px",
              height: "14px"
            })), c.a.createElement(p.a, {
              id: "autosuggest-close-icon",
              effect: "solid",
              "aria-haspopup": "true"
            }, "Удалить")), !e && o && c.a.createElement("div", {
              className: h["after-icon"],
              role: "presentation"
            }, o));
          }, u.shouldRenderSuggestions = function (e) {
            return !u.props.shouldRenderSuggestions || u.props.shouldRenderSuggestions(e, u.props.id);
          }, u.onSuggestionSelected = function (e, t) {
            u.props.onSuggestionSelected && u.props.onSuggestionSelected(e, t, u.props.id);
          }, u.state = {
            placeholder: null,
            focused: !1
          }, u.autocompleteId = g()(), u;
        }
        return e = o, (t = [{
          key: "componentDidMount",
          value: function () {
            document.addEventListener("keydown", this.suggestionHighlightedScroll);
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            document.removeEventListener("keydown", this.suggestionHighlightedScroll);
          }
        }, {
          key: "componentDidUpdate",
          value: function () {
            var e = this.input.scrollLeft;
            this.placeholder.style.marginLeft = "-".concat(e, "px");
          }
        }, {
          key: "render",
          value: function () {
            var e = b({
              placeholder: this.props.placeholder,
              value: this.props.value,
              onChange: this.onChange,
              onFocus: this.handleFocus,
              onBlur: this.handleBlur,
              autoComplete: this.autocompleteId,
              disabled: this.props.disabled
            }, this.props.inputProps);
            return c.a.createElement("div", {
              className: this.props.wrapperClassName,
              "data-qa": this.props.dataQa
            }, c.a.createElement(s.a, {
              highlightFirstSuggestion: void 0 === this.props.highlightFirstSuggestion || this.props.highlightFirstSuggestion,
              id: this.props.id,
              focusInputOnSuggestionClick: !1,
              theme: b(b({}, h), this.props.theme),
              suggestions: this.props.suggestions || [],
              onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
              onSuggestionsClearRequested: this.onSuggestionsClearRequested,
              getSuggestionValue: this.getSuggestionValue,
              renderSuggestion: this.props.renderSuggestion || this.renderSuggestion,
              inputProps: e,
              onSuggestionSelected: this.onSuggestionSelected,
              onSuggestionHighlighted: this.onSuggestionHighlighted,
              renderInputComponent: this.renderInputComponent,
              renderSuggestionsContainer: this.props.renderSuggestionsContainer || this.renderSuggestionsContainer,
              shouldRenderSuggestions: this.shouldRenderSuggestions
            }), this.props.errorDescription && c.a.createElement(l.a, {
              type: "error"
            }, this.props.errorDescription));
          }
        }]) && v(e.prototype, t), r && v(e, r), o;
      }();
      r.defaultProps = {
        dataQa: "autosuggest"
      };
      var j = r;
    }
  }, a.c = u, a.d = function (e, t, r) {
    a.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, a.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, a.t = function (t, e) {
    if (1 & e && (t = a(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (a.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) a.d(r, n, function (e) {
      return t[e];
    }.bind(null, n));
    return r;
  }, a.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return a.d(t, "a", t), t;
  }, a.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, a.p = "", a(a.s = 570);
  function a(e) {
    if (u[e]) return u[e].exports;
    var t = u[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return l[e].call(t.exports, t, t.exports, a), t.l = !0, t.exports;
  }
  var l, u;
});